<template>
    <div class="multiroom-container-stats" v-if="!getStyleEdition">
        <p class="multiroom-container-stats_text">
            {{ getAllInfos.restoName }} -
        </p>

        <popup-resa-details :date="getSelectedDay" :service="getSelectedMainService"
            :title="`${getOccupationByServiceAndDay(getSelectedDay, getSelectedMainService)}/${getAllCouvForAllRooms}<span class='popup-resa-detail-title-couvor'> couverts</span> - `" />

        <p class="popup-resa-detail-occupation"><span class="popup-resa-detail-occupation-text">Occupation:</span>
            <span class="popup-resa-detail-occupation-percentage"> {{
                getPercentOccupation }} %</span>
        </p>

        <el-popover placement="bottom" width="200" v-model="popupStateService" popper-class="popup-delete black-inputs">
            <p>Êtes vous sûr ?</p>

            <div style="text-align: right; margin: 0">
                <el-button size="mini" class="dark" type="primary" @click="popupStateService = false">
                    Annuler
                </el-button>

                <el-button type="primary" size="mini" @click="setStateService">
                    Confirmer
                </el-button>
            </div>

            <span slot="reference">
                <span class="multiroom-container-stats_red" v-if="getCurrentServiceLockState">
                    - <span class="multiroom-container-stats_red-service">Service</span> fermé
                </span>
                <span class="multiroom-container-stats_green" v-else>
                    - <span class="multiroom-container-stats_green-service">Service</span> ouvert
                </span>
            </span>
        </el-popover>

        <popup-discount-display :date="getSelectedDay" :service="getSelectedMainService" />

        <span v-if="cashState(getSelectedMainService)">
            - <span class="multiroom-container-stats_cash-type-desk">{{ cashState(getSelectedMainService).type }}</span>
            <span class="multiroom-container-stats_cash-type-mob">{{ cashState(getSelectedMainService).type[0]
                }}:</span>
            {{ cashState(getSelectedMainService).value }}€ / c
        </span>

        <span v-if="cashState(getSelectedMainService).nbCouv">
            ({{ cashState(getSelectedMainService).nbCouv }})
        </span>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { dateToTimeStamp } from '../../tools/timeTool';
import PopupDiscountDisplay from '../popups/PopupDiscountDisplay';
import PopupResaDetails from '../popups/PopupResaDetails';

export default {
    name: 'MultiRoomStats',
    components: {
        PopupDiscountDisplay,
        PopupResaDetails
    },
    data() {
        return {
            popupStateService: false
        }
    },
    computed: {
        ...mapGetters({
            getAllInfos: 'infos/getAllInfos',
            getStyleEdition: 'newRooms/getStyleEdition',
            getAllCouverts: 'newRooms/getAllCouverts',
            getOccupationByServiceAndDay: 'newReservations/getOccupationByServiceAndDay',
            getRoomNbCouvertsLockedAllRooms: 'newRooms/getRoomNbCouvertsLockedAllRooms',
            getSelectedMainService: 'newServices/getSelectedMainService',
            getSelectedDay: 'calendar/getSelectedDay',
            getAllServices: 'newServices/getAllServices',
            getCurrentServiceLockState: 'newServices/getCurrentServiceLockState',
            getCashDaysList: 'cash/getCashDaysList'
        }),

        getPercentOccupation() {
            if (this.getAllCouvForAllRooms === 0) return '0'
            return Math.round(
                (this.getOccupationByServiceAndDay(
                    this.getSelectedDay,
                    this.getSelectedMainService
                ) / this.getAllCouvForAllRooms) * 100
            )
        },

        getAllCouvForAllRooms() {
            const nbLockedCouv = this.getRoomNbCouvertsLockedAllRooms({
                date: this.getSelectedDay,
                service: this.getSelectedMainService
            })

            return (
                this.getAllCouverts(
                    this.getSelectedDay,
                    this.getSelectedMainService
                ) - nbLockedCouv
            )
        }
    },
    methods: {
        ...mapActions({
            createLockedServices: 'newServices/createLockedServices',
            deleteLockedDays: 'newServices/deleteLockedDays'
        }),

        setStateService() {
            this.popupStateService = false
            const createLockedDay = !this.getCurrentServiceLockState
            const date = new Date(this.getSelectedDay.date)
            const ts = dateToTimeStamp(
                date.getDate(),
                date.getMonth(),
                date.getFullYear()
            )

            if (createLockedDay) {
                this.createLockedServices({
                    days: [ts],
                    service: this.getSelectedMainService
                }).catch(console.error)
            } else {
                this.deleteLockedDays({
                    tIds: [ts],
                    service: this.getSelectedMainService
                }).catch(console.error)
            }
        },

        cashState(service) {
            if (this.getSelectedDay && this.getSelectedDay.date) {
                const date = new Date(this.getSelectedDay.date)
                const ts = dateToTimeStamp(
                    date.getDate(),
                    date.getMonth(),
                    date.getFullYear()
                )

                const cashList = this.getCashDaysList
                let serviceForDay = null

                if (this.getAllServices[service]) {
                    serviceForDay =
                        this.getAllServices[service][this.getSelectedDay.labelDay]
                }

                if (service && cashList && cashList[ts] && cashList[ts][service]) {
                    return cashList[ts][service]
                } else if (serviceForDay && serviceForDay.cashOn) {
                    return {
                        type: serviceForDay.cashType,
                        value: serviceForDay.cashPrice,
                        isOnService: true
                    }
                }
            }
            return ''
        }
    }
}
</script>
